import * as React from 'react';
import classnames from 'classnames';

import { getDiffInDays, getDisplayDate } from 'utils/date';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./campaign-dates.i18n.json'));

import './campaign-dates.scss';

import type { Campaign, CampaignState } from 'types';

type DateType = 'start' | 'end';

type Props = {
  campaign: Campaign
};

const getDateKey = (state: CampaignState, type: DateType): string => {
  let key;

  if (type === 'start') {
    key = state === 'preparation'
      ? 'not_started'
      : 'active.start';
  }

  if (type === 'end') {
    key = state === 'inactive'
      ? 'finished'
      : 'active.end';
  }

  return key ? `campaign_dates.${key}` : '';
};

const getDateClass = (state: CampaignState, type: DateType): string => {
  const baseClass = `campaign-dates__${type}-date`;
  let subClass = '';

  if (type === 'start') {
    subClass = state === 'preparation' ? '--highlighted' : subClass;
  }

  if (type === 'end') {
    subClass = state === 'active' ? '--highlighted' : subClass;
  }

  return classnames(baseClass, {
    [`${baseClass}${subClass}`]: true
  });
};

const CampaignDates = (
  {
    campaign
  }: Props
): JSX.Element => {
  const startDateKey = getDateKey(campaign.state, 'start');
  const endDateKey = getDateKey(campaign.state, 'end');

  const startDate = campaign.state === 'preparation'
    ? getDiffInDays(campaign.startDate)
    : getDisplayDate(campaign.startDate);

  const endDate = getDisplayDate(campaign.endDate);

  return (
    <React.Fragment>
      <div
        className={getDateClass(campaign.state, 'start')}
        title={`${__t('campaign_dates.label_start_date')}: ${getDisplayDate(campaign.startDate)}`}
      >
        {__t(startDateKey, {
          days: startDate,
          date: startDate
        })}
      </div>
      <div
        className={getDateClass(campaign.state, 'end')}
        title={`${__t('campaign_dates.label_end_date')}: ${getDisplayDate(campaign.endDate)}`}
      >
        {__t(endDateKey, {
          date: endDate
        })}
      </div>
    </React.Fragment>
  );
};

export default CampaignDates;
